<ion-item class="input-field">
  <ion-label position="stacked">{{ label }}</ion-label>
  <ion-textarea
    [placeholder]="placeholder"
    [(ngModel)]="inputModel"
    (ngModelChange)="inputModelChange.emit(inputModel)"
    [rows]="rows"
  >
  </ion-textarea>
</ion-item>
